import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const KEY = "onusa_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (i) => `${i.product_id}::${i.size || ""}`;

  const addItem = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => lineKey(p) === lineKey(item));
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: Math.min((next[idx].quantity || 1) + (item.quantity || 1), item.max || 99) };
        return next;
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
    setOpen(true);
  };
  const updateQty = (key, qty) => {
    setItems((prev) => prev.map((p) => (lineKey(p) === key ? { ...p, quantity: Math.max(1, qty) } : p)));
  };
  const removeItem = (key) => setItems((prev) => prev.filter((p) => lineKey(p) !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, addItem, updateQty, removeItem, clear, count, subtotal, lineKey }}>
      {children}
    </CartContext.Provider>
  );
}
